/* eslint no-param-reassign: "error" */
import {
  createSlice,
} from '@reduxjs/toolkit';

import type { EntityDataPubNotNullType } from '../entityPub';
import type { EntityDataPubType } from '@/domain/entityBase';
import type { EntitySubscribeType } from '@/infra/appsync';
import type { PhotoItemJson } from '@/types/domain/photo/entities/photoItemEntity';
import type { PhotoOrderJsonPub, PhotoOrderJsonPvt } from '@/types/domain/photo/entities/photoOrderEntity';
import type { PhotoSalesJsonPub, PhotoSalesJsonPvt } from '@/types/domain/photo/entities/photoSalesEntity';
import type { PayloadAction } from '@reduxjs/toolkit';

import { service } from '@/share';

/**
 * 写真URL
 */
export type PhotoUrlType = {
  /** URL */
  url: string,
  /** サンプルURL */
  urlSample: string,
  /** サムネイルURL */
  urlThumbnail: string
};

/**
 * 写真ステート
 */
export type PhotoStateType = {
  /** 写真注文 */
  photoOrders: EntityDataPubType<PhotoOrderJsonPvt, PhotoOrderJsonPub>[],
  /** 写真注文トークン */
  photoOrdersToken: string | null, // 初期はnull. 最後までいったら空文字
  /** 販売写真 */
  salesPhotos: EntityDataPubNotNullType<PhotoSalesJsonPvt, PhotoSalesJsonPub>[],
  /** 写真アイテムリスト */
  photoItemList: PhotoItemJson[] | undefined,
}

const initialState: PhotoStateType = {
  photoOrders: [],
  photoOrdersToken: null,
  salesPhotos: [],
  photoItemList: undefined,
};

/**
 * 写真Slice
 */
export const photoSlice = createSlice({
  name: 'photo',
  initialState,
  reducers: {
    /** 写真注文トークンをセット */
    setPhotoOrdersToken:
      (state, action: PayloadAction<string | null>) => {
        state.photoOrdersToken = action.payload;
      },
    /** 写真注文をセット */
    setPhotoOrders:
      (
        state,
        action: PayloadAction<EntityDataPubNotNullType<PhotoOrderJsonPvt, PhotoOrderJsonPub>[]>,
      ) => {
        state.photoOrders = action.payload;
      },
    /** 販売写真一覧セット */
    setSalesPhotos:
      (state, action: PayloadAction<
        EntityDataPubNotNullType<PhotoSalesJsonPvt, PhotoSalesJsonPub>[]>) => {
        state.salesPhotos = action.payload;
      },
    /** 写真アイテム一覧セット */
    setPhotoItemList:
      (state, action: PayloadAction<PhotoItemJson[]>) => {
        state.photoItemList = action.payload;
      },
    /** 作成 */
    createOrderStore: (state, action: PayloadAction<EntitySubscribeType>) => {
      if (state.photoOrdersToken !== null) {
        state.photoOrders = service.photo.createPhotoOrderStore(
          state.photoOrders,
          action.payload,
          undefined,
        );
      }
    },
    /** 更新 */
    updateOrderStore: (state, action: PayloadAction<EntitySubscribeType>) => {
      if (state.photoOrdersToken !== null) {
        state.photoOrders = service.photo.updatePhotoOrderStore(
          state.photoOrders,
          action.payload,
        );
      }
    },
  },
});
